export interface PosModel {
  id: number;
  shipIsOther: boolean;
  completed: Date;
  inDate: Date;
  invoice: string;
  venderId: string;
  venderName: string;
  submitted: Date;
  status: string;
  itemCount: number;
  sumQty: number;
  qty: number;
  price: number;
  priceTotal: number;
  ship: number;
  discount: number;
  other: number;
  poTotal: number;
}

export interface PoDetailModel {
  id: number;
  shipIsOther: boolean;
  venderSId: number;
  venderId: string;
  venderName: string;
  venderAddress: string;
  venderPhone: string;
  venderPhone2: string;
  submitted: Date;
  completed: Date;
  status: string;
  note: string;
  invoice: string;
  inDate: Date;
  est: Date;
  ship: number;
  discount: number;
  other: number;
  itemId: string;
  itemName: string;
  itemVenderId: string;
  qty: number;
  bfr: string;
  price: number;
  rec: number;
  total: number;
}

export interface NewPoRequestModel {
  id: number;
  vender: number;
  submitted: string;
  note: string;
  status: string;
  completed: string;
  done: boolean;
  invoice: string;
  inDate: string;
  ship: number;
  discount: number;
  other: number;
  exported: boolean;
  shipIsOther: boolean;
  est: string;
  items: ItemsOfPo[];
}

export interface ItemsOfPo {
  id: string;
  qty: number;
  price: number;
}

export interface EditPoRequestModel {
  id: number;
  submitted: string;
  note: string;
  completed: string;
  invoice: string;
  inDate: string;
  items: ItemsOfPo[];
}

export interface ItemModel {
  itemId: number;
  id: string;
  name: string;
  image: string;
  qty: number;
  vendor: string;
  price: number;
  avgPrice: number;
  note: any;
  itemGrp: number;
  archived: boolean;
  avgTemp: number;
  fbmQty: number;
  isDrp: boolean;
  upc: any;
  caseQ: number;
  enforce: number;
  length: number;
  height: number;
  width: number;
  weight: number;
  vendId: string;
  brand: any;
  inbound: any;
  lQty: any;
  onShelf: any;
  missing: any;
  codes: any;
  itemsId: any;
}

export interface VenderModel {
  sid: number;
  id: string;
  name: string;
  address: string;
  phone: string;
  phone2: string;
  email: string;
  shipAvg: number;
  on1: number;
  on2: number;
  on3: number;
  on4: number;
  leadDays: number;
  purchaseDays: number;
  leadOn: true;
  purchaseAmnt: number;
  vendId: any;
  isManuFact: boolean;
  manufDays: number;
  ma1: number;
  ma2: number;
  ma3: number;
  ma4: number;
}

export interface SavePoPlanPayload {
  planBySku?: boolean;
  planId?: number;
  title?: string;
  skuQtyList?: {
    skuId: number;
    qty: number;
  }[];
  itemQtyList?: {
    itemId: number;
    qty: number;
  }[];
}

export interface PoDetail {
  dateCreated: Date;
  dateSubmited: Date;
  discountAmount: number;
  discountPct: number;
  invoiceDate: Date;
  invoiceNumber: Date;
  isFullyRecieved: boolean;
  itemsCost: number;
  notes: string;
  purchaseOrderId: number;
  purchaseOrderItems: PurchaseOrderItem[];
  recievedDate: Date;
  shippingCost: number;
  status: number;
  statusName: string;
  vendor: string;
  vendorAddress1: string;
  vendorAddress2: string;
  vendorCity: string;
  vendorState: string;
  vendorZipcode: string;
  vendorPhone: string;
  warehouseId: string;
  otherCost:number;
  submittedBy:string;
  subTotal:number;
  expectedOn:string;
  wharehouse: string;
  warehouseAddress1: string;
  warehouseAddress2: string;
  warehouseCity: string;
  warehouseState: string;
  warehouseZipcode: string;
  warehouseCountry: string;
  wharehouseName: string;
  companyName: string;
  companyPhone: string;
  companyEmail: string;
  companyWebsite: string,
  companyAddressLine: string;
  companyCity: string;
  companyState: string;
  companyCountry: string;
  companyZipCode: string;
  companyLogo:string;
  companyCountryCode:string;
  totalQty: number;
  totalRecievedQty:number;
  itemRecieved: number;
  totalItems: number;
  itemPercentage:number;
  unitPercentage: number;
  orderMinimumAmount: number;
  fileName:string;
  companyAddressLine1:string;
  terms:string;

  notesToVendor:string;

  totalCbm:string;

}

export interface PurchaseOrderItem {
  purchaseOrderItemId: number;
  title: string;
  qty: number;
  priceEach: number;
  qtyPrice: number;
  qtyDiscountAmount: number;
  qtyDiscountPct: number;
  totalPrice: number;
  receivedQty: number;
  vendorItemName:string;
  description:string;
  price:number;
  discountAmount:number;
  discountPct: number;
  additionalCostAmount: number;
  additionalCostPct: number;
  cases:number;
  notes:string;
  itemName:string;
  outstandingQty?:number;
  qtyPerCase: number;
  itemId: number;
  poItemNote:string;
}

export interface EditPurchaseOrderPayload {
  poId: number;
  status: number;
  notes: string;
  shippingCost: number;
  discountAmount: number;
  discountPct: number;
  otherCost:number;
  subTotal: number;
  invoiceNumber: string;
  invoiceDate: string;
  recievedDate: string;
  expectedOn: string;
  items: PurchaseOrderItem[];
  receivedQty?: number;
  wharehouse: any;
  dateSubmited:string;
  logoBase64: string,
  logoExtension: string,
  fileName: string,
  logoBase641: string,
  logoExtension1: string,
  fileName1: string,
  logoBase642: string,
  logoExtension2: string,
  fileName2: string;

  notesToVendor:string;

  isVendorPriceUpdate:boolean;

}

export interface CreatePurchaseOrderPayload {
  title?: string;
  vendorId?: number;
}

export interface AddVendorItemToPoPayload {
  itemQty: ItemQty[];
  poId: number;
}


export interface ItemQty {
  vendorItemId: number;
  qty: number;
}

export interface PoStatus {
  count: number;
  id: number;
  status: string
}

export enum RestockTagClasses {
  OrderNow = "order-now",
  OutOfStock = "out-of-stock",
  OrderSoon = "order-soon",
  OverStocked = "overstocked",
  NewItem = "new-item",
  NoActionNeeded = "no-action-needed",
}

export interface GetPurchasingSummaries {
  inventoryValue: number;
  orderSoon: number;
  orderNow: number;
  outOfStock: number;
  reorderAlerts: number;
  suggestedPoValue: number;
  onPoValue: number;
  openPos: number;
  restockSoon?: number;
  restockNow?: number;
  fbaValue:number,
  localValue? : number
}
export enum RestockTag {
  OrderNow = "Order now",
  OutOfStock = "Out of stock",
  OrderkSoon = "Order soon",
  OverStocked = "Overstocked",
  NewItem = "New item",
  NoActionNeeded = "No action needed",
}


export interface SaveSeasonPayload {
  seasonId?: number;
  seasonName: string;
  startDate: string;
  endDate: string;
  percentageChange: string;
}


export interface Breakdown {
  demandBuffers?: any[];
  demandSkus: DemandSkus[]
  draftPos: Pos[]
  events: SaveProductEvent[]
  fbaStockSkus: FbaStockSkus[]
  inboundPos: Pos[]
  seasons?: any[];
  warehouseStock: number;
  inboundPoTotal: number;
  draftPoTotal: number;
  skuDemandTotal: number;
  skuFbaTotal: number;
  eventsTotal: number;
  demandBufferTotal: number;
  seasonsTotal: number;
  vendor:string;
  purchasingDateFrom:Date,
  purchasingDateTo:Date,
  purchasingDay:number,
  leadDays:number,
  leadDateFrom:Date,
  leadDateTo:Date,
  LocalMinusReserved:any
}

export interface DemandSkus {
  account: string;
  accountSkuId: number;
  Asin: string;
  Suggested: number;
  fulfilment: string;
  Image: string;
  Qty: number;
  Sku: string;
  Title: string;
}

export interface Pos {
  poDate: string;
  poNumber: number;
  price: number;
  qty: number;
  status: string;
  totalPrice: number;
  vendorItemName: string;
  vendorName: string;
}

export interface FbaStockSkus {
  account: string;
  accountSkuId: number;
  Asin: string;
  Image: string;
  Sku: string;
  TotalFbaStock: number;
  Title: string;
  AmountAdjustedOnItem?: number;
}

export interface SaveProductEvent {
  productEventId?: number;
  productId: number;
  description: string;
  eventDate:string;
  amount: number;
}

export interface AddProductToSeasons {
  productId: number;
  seasonIds: number[];
}